export default "__VITE_ASSET__DLjTbowp__"